import { Component } from '@angular/core';
import { FeaturePreviewComponent } from '../feature-preview.component';

@Component({
  selector: 'app-feature-preview-planering',
  templateUrl: './planering.component.html',
})
export class FeaturePreviewPlanering extends FeaturePreviewComponent {}
